import { useNavigate } from "react-router-dom";

import { ActionBtn } from "../../../../../../../Components/FinalTable";

const TableAction = ({ doc }) => {
  const navigate = useNavigate();

  function handleNext() {
    if (doc.checked_out === true) {
      return;
    }
    navigate(`/dashboard/next-step/${doc.id}`);
  }

  return (
    <div className="flex-1">
      {/* <TableHorizontalActionBtn /> */}
      <ActionBtn showOptions={false} next={handleNext}>    
      </ActionBtn>
    </div>
  );
};

export default TableAction;
